function parse(version: string): [number, number, number] {
    // https://regex101.com/r/Ly7O1x/3/
    const pattern = /^(?<major>0|[1-9]\d*)\.(?<minor>0|[1-9]\d*)\.(?<patch>0|[1-9]\d*)(?:-(?<prerelease>(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+(?<buildmetadata>[0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/g;

    const {groups} = pattern.exec(version);
    const major = parseInt(groups['major']);
    const minor = parseInt(groups['minor']);
    const patch = parseInt(groups['patch']);

    return [major, minor, patch];
}

class MemberVersion {

    readonly major: number;
    readonly minor: number;
    readonly patch: number;

    public get isUnknown(): boolean {
        return this.major === 0 && this.minor === 0 && this.patch === 0;
    }

    public toString(): string {
        return `${this.major}.${this.minor}.${this.patch}`;
    }

    constructor(major: number, minor: number, patch: number) {
        this.major = major;
        this.minor = minor;
        this.patch = patch;
    }
}

export const UNKNOWN_VERSION: MemberVersion = new MemberVersion(0, 0, 0);

export function parseVersion(version?: string): MemberVersion {
    if (!version || version.startsWith('0.0.0')) {
        return UNKNOWN_VERSION;
    }
    return new MemberVersion(...parse(version));
}

export type {MemberVersion};
